import styled from "styled-components";

const Wrapper = styled.h4`
  margin-top: 4vh;
  margin-bottom: 1.5vh;

  font-size: 1em;
  font-weight: 700;
  line-height: 1.4em;
  text-align: left !important;
`;

const NewsHeading = (props: { children?: any }) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default NewsHeading;
